import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider
} from "react-router-dom";
import { RouterHome } from "./app-home/_router-home";
import { RouterPatient } from "./app-patient/_router-patient";
import { RouterReports } from "./app-reports/_router-reports";
import { RouterUsers } from "./app-users/_router-users";
import { AuthProvider } from "./auth-context";
import "./dev";
import "./main.css";
import Header from "./page/header";
import PageLogin from "./page/page-login";
import ProtectedRoutes from "./protected-route";
import { RequestContextProvider } from "./request-context";
import ErrorPage from "./widget/error-page";

function PageMain() {
  return (
    <div className="container-fluid" data-testid="top-level">
      <AuthProvider>
        <Header />
        <RequestContextProvider>
          <Outlet />
        </RequestContextProvider>
      </AuthProvider>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <PageMain />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Navigate to="/home" replace /> },
      {
        path: "/login/*",
        element: <PageLogin />,
        errorElement: <ErrorPage />
      },
      {
        element: <ProtectedRoutes />,
        children: [
          ...RouterHome(),
          ...RouterPatient(),
          ...RouterReports(),
          ...RouterUsers()
        ]
      }
    ]
  }
]);

createRoot(document.querySelector("body")!).render(
  <RouterProvider router={router} />
);
